export { default } from "./SimpleLinePlaceholder";
